import { InvoiceColumns } from 'columns/Invoice';
import { BillingDataGridWrapper } from 'components/common';
import type { Invoice } from '@billing/validation/invoice';
import { MRT_ColumnDef, MRT_TableOptions } from 'mantine-react-table';

export const InvoiceManagement = () => {
  const title = 'Invoice';

  const columns: MRT_ColumnDef<Invoice>[] = InvoiceColumns();

  const tableOptions: MRT_TableOptions<Invoice> = {
    data: [],
    columns,
    state: {
      showAlertBanner: false,
      showProgressBars: false,
      isLoading: false,
    },
  };

  return (
    <BillingDataGridWrapper
      title={title}
      dataTestID="invoiceManagement"
      tableOptions={tableOptions}
    />
  );
};
